import { Form } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { reactSelectStyles } from "shared/config";

/**
 * Component has been deprecated and should not be used anymore.
 * @deprecated Use components from shared/ui instead
 */
function FormSearchableSelect({
  name,
  options,
  label = "",
  displayAs = Form.Group,
  changeHandler = undefined,
  defaultValue = undefined,
  ...props
}) {
  const { t } = useTranslation("Shared");
  const {
    formState: { errors },
  } = useFormContext();
  return (
    <Form.Group className="d-flex flex-column" as={displayAs}>
      <Form.Label>{label}</Form.Label>
      <Controller
        name={name}
        shouldUnregister
        render={({ field }) => (
          <Select
            placeholder={t("placeholders.select")}
            styles={reactSelectStyles}
            classNames={{
              control: () => (errors[name] ? "border-error" : ""),
            }}
            className={errors[name] ? "is-invalid" : ""}
            isSearchable
            onChange={(event) => {
              field.onChange(event);
              changeHandler && changeHandler(event, name);
            }}
            value={field.value}
            options={options}
            {...props}
          />
        )}
      />
      <Form.Control.Feedback type="invalid">
        {errors[name]?.message.toString()}
      </Form.Control.Feedback>
    </Form.Group>
  );
}

export default FormSearchableSelect;
